<div *ngIf="vm$ | async as vm" class="ca-main">
  <div class="ca-main__header">
    <h2>{{ "Kommunenauswahl" | translate }}</h2>
    <button
      *ngIf="isCreateMunicipalityEnabled"
      ene-filled-button
      size="large"
      data-cy="create-municipality-button"
      (click)="openCreateMunicipalityDialog()"
    >
      {{ "CONFIGURATION_AREA.DIALOGS.CREATE_MUNICIPALITY.TITLE" | translate }}
    </button>
  </div>
  <ngmy-table
    class="modules-table"
    [scrollableY]="true"
    [disableSort]="false"
    [sortActive]="'name'"
    [sortDirection]="'asc'"
    [pagingConfig]="pagingConfig"
    [columnsConfig]="vm.columns"
    [loading]="false"
    [data]="vm.list"
    (tableAction)="onTableEvent($event)"
  ></ngmy-table>
</div>
